import React from 'react'
import PropTypes from 'prop-types';
import MarbleScore from '../MarbleScore/MarbleScore';
import Principles from '../Principles/Principles';
import SectionVideoGrid from '../SectionVideoGrid/SectionVideoGrid';

function StaticContent({ assets = [], entries = [], fields = {} }) {
  const {
    name, backgroundColor
  } = fields;

  if (name === "Marble Score") {
    return (
      <MarbleScore backgroundColor={backgroundColor} />
    )
  }

  if (name === "Principles") {
    return (
      <Principles backgroundColor={backgroundColor} />
    )
  }

  if (name === "Section Video Home") {
    return (
      <SectionVideoGrid assets={assets} entries={entries} fields={fields} />
    )
  }

  return (
    <div className="aaco-static-content">
      <h1>{name}</h1>
    </div>
  )
}

StaticContent.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
};

export default StaticContent
